import { inject, observer } from "mobx-react";
import React from "react";
import { Button, Icon } from "src/components";
import { Meeting } from "src/models";
import { LogStore, UserStore } from "src/stores";
import { LogEntry } from "./logEntry";

export interface ISummaryViewProps {
  logStore?: LogStore;
  userStore?: UserStore;
  item: Meeting;
}

export const SummaryView = inject(
  "logStore",
  "userStore"
)(
  observer((props: ISummaryViewProps): JSX.Element => {
    const { logStore, userStore, item } = props;
    const logItems = logStore.meetingSummary.getArray;

    return (
      <>
        <div style={{display: "flex", flexDirection:"row-reverse"}}>
        <Button
            variant="icon"
            onClick={() => logStore.generateMeetingSummary(item.id, "pdf")}
          >
            <Icon size="large" iconId="pdf" />
          </Button>
          <Button
            variant="icon"
            onClick={() => logStore.generateMeetingSummary(item.id, "xlsx")}
          >
            <Icon size="large" iconId="excel" />
          </Button>
        </div>
        {logItems.map((item) => (
          <LogEntry
            key={item.id}
            user={props.userStore.getItemByID(item.user_id)}
            log={item}
            item={props.logStore.rootStore.getActiveItem}
            itemType={props.logStore.rootStore.getActiveItemType}
          />
        ))}
      </>
    );
  })
);
